import { render } from "./MerchantOrderList.vue?vue&type=template&id=380dd408&scoped=true"
import script from "./MerchantOrderList.vue?vue&type=script&lang=js"
export * from "./MerchantOrderList.vue?vue&type=script&lang=js"

import "./MerchantOrderList.vue?vue&type=style&index=0&id=380dd408&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380dd408"]])

export default __exports__